<router-outlet />

<!-- Full-page loader overlay for navigation/resolver loading -->
@if (isLoading()) {
  <div class="app-loader-overlay">
    <div class="app-loader-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </div>
}